import { useMongoUpdate } from "contexts/useMongoQuery";

export const useUpdateDock = (completed?: () => void) => {
  const [updateDockMutation, { error }] = useMongoUpdate("docks", false, {}, completed);
  /**
   * Function to update data
   * @param id _id of document to update
   * @param set New data to set
   * @returns Mutation variables {updateData, error}
   */
  const updateData = async (id: string | number, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
    const { data } = await updateDockMutation({ _id: id}, set);
    const updatedData: { [key: string]: any } = data || {}
    return { updatedData: updatedData, error };
  };
  return updateData;
}
